import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-foreground-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="w-full max-w-xs md:max-w-sm flex-shrink-0">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/20 rounded-3xl blur-2xl"></div>
              <div className="relative bg-foreground-800 rounded-3xl p-3 border border-foreground-700/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20entertainment%20news%20app%20interface%20with%20dark%20theme%20design%2C%20trending%20gossip%20headlines%20on%20screen%2C%20bold%20red%20accent%20colors%2C%20clean%20UI%20with%20ranking%20list%20display%2C%20minimalist%20phone%20mockup%20on%20simple%20dark%20background%2C%20professional%20product%20photography%20with%20soft%20lighting%2C%20sleek%20modern%20aesthetic&width=600&height=900&seq=app-mockup-01&orientation=portrait"
                  alt="黑料每日大赛 App 界面预览"
                  className="w-full rounded-2xl"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-accent-400 font-semibold mb-5">{appData.subtitle}</p>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6 max-w-lg">
              {appData.description}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8 max-w-md mx-auto lg:mx-0">
              {appData.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-sm text-foreground-200">
                  <div className="w-5 h-5 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-xs"></i>
                  </div>
                  <span>{feat}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a href="#app" className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap text-center">
                {appData.downloadText}
              </a>
              <a href="#app" className="w-full sm:w-auto px-8 py-3.5 border border-foreground-600 text-foreground-200 font-semibold rounded-lg hover:border-foreground-400 hover:text-background-50 transition-colors text-sm whitespace-nowrap text-center">
                {appData.qrText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}